import Button from '../../../../kingpin/atoms/Button';
import React, { useCallback, useContext } from 'react';
import BonusPeriodsContext from '../../../../contexts/BonusPeriodsContext';
import AnalyticsContext from '../../../../contexts/AnalyticsContext';
import { BonusOverviewContext } from '../../providers/BonusOverviewProvider';
import getOverrideDisabledMessage from '../../utils/getOverrideDisabledMessage';

export const OverrideButton = ({
  selectedBonusPeriod,
  selectedSubPeriod,
  onClicked,
  icon,
}: {
  selectedBonusPeriod?: BonusTypes.BonusPeriod;
  selectedSubPeriod?: Period;
  onClicked: () => void;
  icon?: Kingpin.Icon;
}) => {
  if (!selectedBonusPeriod) {
    return null;
  }

  // The button stays visible but disabled when overrides aren't allowed, so
  // the reason shows.
  const disabledMessage = getOverrideDisabledMessage({
    selectedBonusPeriod,
    selectedSubPeriod,
  });

  return (
    <Button
      size={'Medium'}
      type={'Primary'}
      label={'Override'}
      onClick={onClicked}
      icon={icon}
      isDisabled={!!disabledMessage}
      isDisabledMessage={disabledMessage}
    />
  );
};

const EnterOverrideModeButton = () => {
  const { selectedBonusPeriod, selectedSubPeriod } =
    useContext(BonusPeriodsContext);
  const { trackEvent } = useContext(AnalyticsContext);
  const { enterOverrideMode } = useContext(BonusOverviewContext);

  const onOverrideClicked = useCallback(() => {
    if (!selectedBonusPeriod) {
      return;
    }

    trackEvent('Driver Bonus - Override Mode Entered', {
      periodId: selectedBonusPeriod.id,
    });
    enterOverrideMode();
  }, [enterOverrideMode, selectedBonusPeriod, trackEvent]);

  return (
    <OverrideButton
      selectedBonusPeriod={selectedBonusPeriod}
      selectedSubPeriod={selectedSubPeriod}
      icon={'checkmark'}
      onClicked={onOverrideClicked}
    />
  );
};

export default EnterOverrideModeButton;
